//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: 'BenefitTableRow',

	props: {
		title: {
			type: String,
			required: true,
		},
		subtitle: {
			type: String,
			required: false,
		},
		checks: {
			'type': Number,
			'default': 3,
		},
	},
};
